<div class="grid-header-content grid-row-selector {{#if isLastColumn}}column-management-offset{{/if}}">
    <input type="checkbox" class="grid-all-rows-selector" aria-label="{{locale "selectAllRows"}}" title="{{locale "selectAllRows"}}" id="select-all-checkbox-{{id}}" />
    <label for="select-all-checkbox-{{id}}" class="sr-only">{{locale "selectAllRows"}}</label>
    {{ title }}
    <span class="pseudoCheckbox" />
    {{#if isResizable}}
        <div role="presentation" class="grid-column-resize-marker">&nbsp;</div>
    {{/if}}
</div>
